import { render, staticRenderFns } from "./s-form-checkbox-group.vue?vue&type=template&id=637df59e"
import script from "./s-form-checkbox-group.vue?vue&type=script&lang=js"
export * from "./s-form-checkbox-group.vue?vue&type=script&lang=js"
import style0 from "./s-form-checkbox-group.vue?vue&type=style&index=0&id=637df59e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports